import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, VStack, Stat, StatLabel, StatNumber, useBreakpointValue, Button } from '@chakra-ui/react';
import Hero1 from '../../assets/images/Hero1.png';
import Hero2 from '../../assets/images/Hero2.png';
import Hero3 from '../../assets/images/Hero3.png';
import Hero4 from '../../assets/images/Hero4.png';
import Hero5 from '../../assets/images/Hero5.png';

const HeroSection: React.FC = () => {
  const images = [Hero1, Hero2, Hero3, Hero4, Hero5];

  const [bgIndex, setBgIndex] = useState(0);
  const [counters, setCounters] = useState({
    raised: 0,
    donations: 0,
    projects: 0,
    members: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    const targetValues = { raised: 300060, donations: 350, projects: 8, members: 478 };
    const incrementSpeed = 50;

    const interval = setInterval(() => {
      setCounters((prevCounters) => ({
        raised: Math.min(prevCounters.raised + 50000, targetValues.raised),
        donations: Math.min(prevCounters.donations + 5, targetValues.donations),
        projects: Math.min(prevCounters.projects + 1, targetValues.projects),
        members: Math.min(prevCounters.members + 100, targetValues.members),
      }));
    }, incrementSpeed);

    return () => clearInterval(interval);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Define the number of columns based on the screen size
  const gridTemplateColumns = useBreakpointValue({ base: "1fr 1fr", md: "1fr 1fr", lg: "1fr 1fr 1fr 1fr" });

  return (
    <Box
      h="100vh"
      position="relative"
      bgImage={`url(${images[bgIndex]})`}
      bgSize="cover"
      bgPosition="center"
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      textAlign="center"
      transition="background-image 1.5s ease-in-out"
      mt={{ base: "-24px", md: "0" }}
      px={{ base: 6, md: 8 }}
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: "rgba(0, 0, 0, 0.4)", // Filtro oscuro con opacidad
        zIndex: 0,
      }}
    >
      <VStack spacing={{ base: 5, md: 6 }} zIndex={1} mb={{ base: 6, md: 10 }} maxW="100%">
        <Heading
          as="h1"
          fontSize={{ base: "5xl", sm: "4xl", md: "5xl", lg: "6xl" }}
          bgGradient="linear(100deg, #0ef1fa, #2ba1ce)"
          bgClip="text"
          fontWeight="700"
          fontFamily="Impact, 'Arial Black', 'Helvetica Neue', Arial, sans-serif"
          lineHeight="shorter"
          px={{ base: 4, md: 0 }}
        >
          Humanizamos la tecnología
        </Heading>
        <Text
          fontSize={{ base: "lg", sm: "xl", md: "2xl", lg: "3xl" }}
          color="gray.200"
          fontWeight="700"
          px={{ base: 4, md: 0 }}
          lineHeight={{ base: "shorter", md: "base" }}
        >
          Servicios informáticos y soluciones digitales a medida <br />
          TRANSFORMA TU EMPRESA
        </Text>

      </VStack>


    </Box>
  );
};

export default HeroSection;
